import { useState } from 'react'
import { NavLink } from "react-router-dom"
import ToggleSwitch from "./ToggleSwitch"

export const Header = () => {

    const [navBarOpen, setNavbarOpened] = useState(false);

    const handleNavbar = () => {
        setNavbarOpened(!navBarOpen);
    }

    return (
        <>
            <button className="navbar-toggler d-block d-md-none d-lg-none outsidemenu" type="button" onClick={handleNavbar}>
                <span className="navbar-toggler-icon"></span>
            </button>
            <nav className={`navbar navbar-expand-lg col-12 col-lg-7 col-md-12 ${navBarOpen ? "opened" : "closed"} `}   >
                <div className="container">

                    <button className="navbar-toggler" type="button" onClick={handleNavbar}>
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="" id="navbarToggler">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                                <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : 'inactive')}> Home  </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/resume" className={({ isActive }) => (isActive ? 'active' : 'inactive')}> Resume  </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/projects" className={({ isActive }) => (isActive ? 'active' : 'inactive')}> Projects  </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/contact" className={({ isActive }) => (isActive ? 'active' : 'inactive')}> Contact  </NavLink>
                            </li>
                        </ul>
                        <ToggleSwitch label="Notifications"  />
                     
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Header